import { useEffect, useState } from 'react';
import { values } from 'lodash';
import WereSearching from '../../../images/we-are-searching.svg';
import Loader from '../../../images/tabler_loader.svg';
import CheckCircle from '../../../images/checkmark-circle.svg';
import * as Styled from './SearchResultsStyles';
import wsClient from '../../ws/client';
import auth from '../../services/authentication';
import EntityIcon from '../../components/EntityIcon/EntityIcon';
import useObservable from '../../hooks/useObservable';
import SubscriptionsStore from '../../xstores/subscriptions';
import SearchStore from '../../xstores/search';

interface SearchLoadingProps{
  isLoading: boolean,
}

interface PlatformDataProps{
  [key:string]: boolean
}

let plData = {};
let searchId = '';

const SearchLoading = ({ isLoading }:SearchLoadingProps) => {
  const [wsConnection, setWsConnection] = useState<object|null|undefined>(null);
  const [platformData, setPlatformData] = useState<PlatformDataProps>({});
  const subscriptions = useObservable(SubscriptionsStore.normalized$, {});
  const searchQuery = useObservable(SearchStore.searchQuery$, '');

  const updatePlatformData = (data:any) => {
    // if there is only one platform left
    // prolong the loading until the paged results come through
    const platformsLeft = values(plData).filter(v => !v).length;
    if (platformsLeft === 1 && !wsConnection) {
      return;
    }
    plData = {
      ...plData,
      [data.platform]: data.ok
    }
    setPlatformData(plData);
  }

  /*const mockResponses = () => {
    let plIdx = 0;
    if (!subscriptions) {
      const timeout = setTimeout(() => {
        mockResponses();
        console.log('no subscriptions');
        clearTimeout(timeout);

      }, 1000);
      return;
    }
    console.log('mock responses');
    const subPlatforms = Object.keys(subscriptions);
    const interval = setInterval(() => {
      updatePlatformData({
        platform: subPlatforms[plIdx],
        ok: true,
      });
      plIdx += 1;
      if (plIdx === subPlatforms.length - 1) {
        clearInterval(interval);
      }
    }, 1000);
  }*/
  useEffect(() => {
    if (!subscriptions) {
      return;
    }
    const subPlatforms = Object.keys(subscriptions);
    const platformStatus = {};
    subPlatforms.forEach((pl: string) => {
      //@ts-ignore
      platformStatus[pl] = false;
    });
    plData = {...platformStatus};
    setPlatformData(plData);
  }, [subscriptions, searchQuery]);

  useEffect(() => {
    if (!searchQuery) {
      return;
    }
    const connection = wsClient({
      url: 'ws-search',
      queryParams: {
        query: searchQuery,
        token: auth.getToken(),
      },
      onConnect: () => {
        setWsConnection(connection);
      },
      onDisconnect: async () => {
        // no connection made
        /*if (!wsConnection) {
          // if socket does not connect fallback to old API
          // or disconnects without giving a searchId
          await SearchStore.search();
        } else {
          SearchStore.setSearchId(searchId);
        }*/
        //mockResponses();
        SearchStore.setSearchId(searchId);
        setWsConnection(null);
      },
      onMessage: (data:any) => {
        if (data.search_id) {
          searchId = data.search_id;
          return;
        }
        updatePlatformData(data);
      },
    });
  }, [searchQuery]);

  if (!isLoading) {
    return null;
  }
  /*if (!wsConnection) {
    return (
      <Styled.VideoContainer>
        {showStatic ?
          <img src={LoadingFinal} alt="loading icon" /> :
          <img src={LoadingShort} alt="loading icon" />
        }
      </Styled.VideoContainer>
    )
  }*/
  return (
    <Styled.VideoContainer>
      <img src={WereSearching} alt="searching..." />
      {Object.keys(platformData).map((key) => (
        <Styled.PlatformLoader key={key}>
          <EntityIcon entityName={key} size={'med'} />
          {platformData[key]
            ? <img width={24} src={CheckCircle} alt="load done" />
            : <img width={24} src={Loader} className="loading-circle" alt="loading platform" />
          }
        </Styled.PlatformLoader>
      ))}
    </Styled.VideoContainer>
  )
}

export default SearchLoading;